export default "__VITE_ASSET__2d46939e__"